"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessagesData = exports.BaseChat = void 0;
const mappers_1 = require("../mappers");
const Message_1 = __importDefault(require("../message/Message"));
const models_1 = require("../models");
const roleAccess_1 = require("../roleAccess/roleAccess");
const Observable_1 = require("../socket/Observable");
const utils_1 = require("../utils");
const CollectionUtils_1 = require("../utils/CollectionUtils");
const DomainEvents_1 = require("../utils/DomainEvents");
const ReferralRevokeFailException_1 = require("./exceptions/ReferralRevokeFailException");
class BaseChat {
    constructor(chatInfo, httpAdapter, socketAdapter, userDirectory, organizationUser, chatsChatInfo) {
        this.changeListeners = [];
        this.removeListeners = [];
        this._chatInfo = chatInfo;
        this.userDirectory = userDirectory;
        this.organizationUser = organizationUser;
        this.httpAdapter = httpAdapter;
        this.socketAdapter = socketAdapter;
        this._messages = (0, exports.defaultMessagesData)();
        this.mediaList = [];
        this.mediaBlobMap = new Map();
        this.chatsChatInfo = chatsChatInfo;
    }
    updateMessageListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UPDATE_MESSAGE, this.getChatId()), (message) => this.updateMessage(cb, message));
    }
    deleteMessageListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.DELETE_MESSAGE, this.getChatId()), (message) => {
            this.deleteMessage(cb, message);
        });
    }
    updateMessage(callback, message, isPendingMessage = false) {
        const finalMessage = (0, mappers_1.messageMapper)(message, this.userDirectory, this.organizationUser.getOrganization());
        if (finalMessage) {
            const updatedMessage = this.processMessageData(finalMessage, message.messageId);
            if (this._messages.mediaList !== undefined &&
                this._messages.mediaList.length > 0) {
                this._messages.mediaList = this._messages.mediaList.map(message => {
                    const isSameMessage = isPendingMessage
                        ? message.getMessage().messageId ===
                            updatedMessage.getMessage().messageId
                        : message.getMessage().id === updatedMessage.getMessage().id;
                    return isSameMessage ? updatedMessage : message;
                });
            }
            this._messages.messages = this._messages.messages.map(message => {
                const isSameMessage = isPendingMessage
                    ? message.getMessage().messageId ===
                        updatedMessage.getMessage().messageId
                    : message.getMessage().id === updatedMessage.getMessage().id;
                return isSameMessage ? updatedMessage : message;
            });
        }
        callback(this._messages);
    }
    deleteMessage(callback, deletedMessage) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._messages.mediaList !== undefined &&
                this._messages.mediaList.length > 0) {
                this._messages.mediaList = this._messages.mediaList.filter(message => {
                    return message.getMessage().id !== deletedMessage._id;
                });
            }
            this._messages.messages = this._messages.messages.map(message => {
                if (message.getMessage().id === deletedMessage._id) {
                    message.updateMessageStatus(models_1.MESSAGE_STATUS.DELETED);
                    return this.makeDetachedMessage(message.getMessage());
                }
                return message;
            });
            callback(this._messages);
        });
    }
    /**
     * A message whose state changed in place keeps its object identity, which
     * React.memo reads as "nothing changed" — the row never repaints. Swapping in
     * a fresh instance is what makes the change visible.
     *
     * Built directly rather than via makeMessage(), deliberately without a
     * changeListener: the original instance's listener (registered when it was
     * first loaded) already covers notifying the chat, and wiring a second one
     * here would leak another Observable subscription with no way to ever
     * unsubscribe it.
     */
    makeDetachedMessage(message) {
        return new Message_1.default(message, this.socketAdapter, this.httpAdapter, this.userDirectory, this.organizationUser, this);
    }
    processMessageData(message, messageIdKey) {
        const pushMessage = this.makeMessage(message);
        if (models_1.MESSAGE_CONTENT_MEDIA_TYPE.includes(message.contentType)) {
            // TODO: i. move this method to the cache abstraction. ii. keep the messageData immutable
            // let image: IMessageData = message.getMessage();
            // const cachedUrl = caches.get(image.getS3Url())
            // if (cachedUrl) {
            //   image = new MessagData(messageData, imageUrl);
            // }
            if (this.mediaBlobMap.has(messageIdKey)) {
                switch (message.contentType) {
                    case models_1.MESSAGE_CONTENT_TYPE.IMAGE:
                        // eslint-disable-next-line no-case-declarations
                        const blogImageData = this.mediaBlobMap.get(messageIdKey);
                        if (blogImageData) {
                            const { images } = pushMessage.getMessage();
                            if (images && images.length > 0) {
                                images[0].url = blogImageData.url;
                                images[0].text = blogImageData.text;
                            }
                        }
                        break;
                }
            }
            // TODO: handle else
        }
        return pushMessage;
    }
    makeMessage(message) {
        return new Message_1.default(message, this.socketAdapter, this.httpAdapter, this.userDirectory, this.organizationUser, this, this.notifyChange.bind(this));
    }
    notifyChange() {
        this.changeListeners.forEach(l => l.cb(this));
    }
    messageChanged() {
        this.notifyChange();
    }
    destory() {
        this.removeListeners.forEach(removeListener => removeListener());
        this.removeListeners = [];
    }
    __test__triggerChangeListener(chat) {
        this.changeListeners && this.changeListeners.forEach(l => l.cb(chat));
    }
    getMessageById(messageId) {
        return this._messages.messages.find(message => message.getMessage().id === messageId);
    }
    get messages() {
        return this._messages;
    }
    getMessageRequest(filters) {
        const total = this._messages.messages.length > 0 ? this._messages.messages.length : 0;
        return Object.assign({ limit: utils_1.HHNConstants.MESSAGE_PAGINATION_LIMIT, chatType: this.getChatType(), total }, (filters && this.populateMessageFilter(filters)));
    }
    populateMessageFilter(filters) {
        return Object.assign(Object.assign({}, (filters.search && { search: filters.search })), (filters.filterBySenderIds && {
            filterBySenderIds: JSON.stringify(filters.filterBySenderIds),
        }));
    }
    upsertMessages(existingMessages, existingMediaList, messagesToUpsert, mergeHandler, order, customAppendFn) {
        const mediaListMergeResult = (0, CollectionUtils_1.mergeAppendToArray)(existingMediaList, messagesToUpsert.mediaList, m => m.getMessage().id, order, false, customAppendFn);
        const messagesMergeResult = (0, CollectionUtils_1.mergeAppendToArray)(existingMessages.messages, messagesToUpsert.messages, m => m.getMessage().id, order, false, customAppendFn);
        const messages = Object.assign(Object.assign({}, mergeHandler(existingMessages, messagesToUpsert)), { messages: messagesMergeResult.mergedItems, mediaList: mediaListMergeResult.mergedItems });
        return {
            messages,
            mediaList: mediaListMergeResult.mergedItems,
            newMessages: messagesMergeResult.newItems,
        };
    }
    fetchAndUpsertMessages(filters, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const messageResponse = yield this.httpAdapter
                .getMessageAdapter()
                .getMessages(this.getChatId(), this.getMessageRequest(filters), context);
            if (!messageResponse.isAborted) {
                const newMessagesList = (0, mappers_1.messagesMapper)(messageResponse.data, this.userDirectory, this.organizationUser.getOrganization(), this.makeMessage.bind(this));
                ({ messages: this._messages, mediaList: this.mediaList } =
                    this.upsertMessages(this._messages, this.mediaList, newMessagesList, (_, newMessaages) => {
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        const { messages, mediaList, messageFilters } = newMessaages, restData = __rest(newMessaages, ["messages", "mediaList", "messageFilters"]);
                        return Object.assign(Object.assign({}, restData), { messageFilters: filters });
                    }, "APPEND"));
            }
            return messageResponse;
        });
    }
    get chatInfo() {
        return this._chatInfo;
    }
    isMentionedUserHas(mentionedUserIds, role) {
        var _a;
        if (mentionedUserIds.length === 0) {
            return false;
        }
        const chatMembers = (_a = this.chatInfo) === null || _a === void 0 ? void 0 : _a.members;
        // check if any of the mentioned user is patient from chatMembers
        return mentionedUserIds.some(mentionedUserId => {
            return chatMembers.some(member => {
                const userInfo = this.userDirectory.getUserInfo(member.userId);
                return member.userId === mentionedUserId && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) === role;
            });
        });
    }
    isMentionedUserHasPatient(mentionedUserIds) {
        return this.isMentionedUserHas(mentionedUserIds, models_1.USER_TYPE.PATIENT);
    }
    isMentionedUserHasPhysician(mentionedUserIds) {
        return this.isMentionedUserHas(mentionedUserIds, models_1.USER_TYPE.PHYSICIAN);
    }
    isPrivate() {
        return this.getChatType() === models_1.CHAT_TYPE.PRIVATE;
    }
    isBroadcast() {
        return this.getChatType() === models_1.CHAT_TYPE.BROADCAST;
    }
    isMember() {
        if (this.getChatType() === models_1.CHAT_TYPE.BROADCAST) {
            return true;
        }
        const storedIsMember = this.chatsChatInfo.getIsMember(this.getChatId());
        if (storedIsMember !== undefined) {
            return storedIsMember;
        }
        return (this.getChatType() === models_1.CHAT_TYPE.GROUP &&
            (this.chatInfo.isMember === true ||
                this.chatInfo.isMember === undefined));
    }
    isPatientGroup() {
        return this.chatInfo.groupType === models_1.GROUP_TYPE.PATIENT;
    }
    isPatientOrInternalGroup() {
        return [models_1.GROUP_TYPE.PATIENT, models_1.GROUP_TYPE.NON_PATIENT].includes(this.chatInfo.groupType);
    }
    revokeReferral(userId, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            const revokeReferralRequest = {
                group: groupId,
                userId,
            };
            // eslint-disable-next-line no-useless-catch
            try {
                if (!this.organizationUser.hasAccess(roleAccess_1.FEATURES.REVOKE_REFERRALS))
                    throw new Error(utils_1.ErrorMessages.noAccessFound);
                const revokedReferral = yield this.httpAdapter
                    .getChatAdapter()
                    .revokeReferral(revokeReferralRequest);
                if (!revokedReferral) {
                    throw new ReferralRevokeFailException_1.ReferralRevokeFailException();
                }
            }
            catch (e) {
                throw e;
            }
        });
    }
}
exports.BaseChat = BaseChat;
const defaultMessagesData = () => {
    return {
        hasNext: false,
        id: "",
        isMember: false,
        lastMessageRead: "",
        limit: 0,
        mediaList: [],
        messages: [],
        total: 0,
        unreadCount: 0,
        messageFilters: undefined,
    };
};
exports.defaultMessagesData = defaultMessagesData;
